import "./block-logos-slider.scss";

const $ = jQuery.noConflict();

function blockLogosSlider() {
    $(".b-logos-slider--layout-slider .slider-logos").each(function onEach() {
        const args = {
            slidesPerView: 6,
            loop: true,

            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },

            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },

            speed: 3000,
        };

        if (this.dataset.autoplay) {
            args.autoplay = {
                delay: 1,
            };
        }

        // eslint-disable-next-line no-undef, no-new
        new Swiper($(this)[0], args);
    });
}

$(document).ready(function onReady() {
    blockLogosSlider();
});

if (window.acf) {
    window.acf.addAction("render_block_preview", blockLogosSlider);
}
